import { observable, action, runInAction } from "mobx";
import * as TenantInfoAPI from "../../../api/pc/tenantInfo";
import { MDialog } from "@weapp/ui";
import { getLabel } from "@weapp/utils";
import { getQueryString, setTokenStorage } from "../../../utils";

const { toast } = MDialog;

export class mTeamsInfoStore {
    @observable tenantList: any[] = []
    @observable loading: boolean = false

    @action
    init = () => {
        //是否邮件回调
        if (getQueryString('urlKey')) {
            TenantInfoAPI.emailCallback({ shortKey: getQueryString('urlKey') }).then((result: any) => {
                if (result?.data?.errorMsg) {
                    const msg = result?.data?.errorMsg;
                    toast({
                        content: getLabel(msg.i18nId, msg.msg)
                    })
                } else {
                    runInAction(() => {
                        if (result.data?.userIdToken) {
                            setTokenStorage(result.data?.userIdToken);
                        }
                    });
                }
            })
        } else {
            this.findApplyTenant();
        }
    }

    @action
    findApplyTenant = () => {
        TenantInfoAPI.queryApplyTenant().then((result: any) => {
            if (result?.data?.errorMsg) {
                const msg = result?.data?.errorMsg;
                toast({
                    content: getLabel(msg.i18nId, msg.msg)
                })
            } else {
                runInAction(() => {

                    if (result.data.applyInviteStr) {
                        this.tenantList = JSON.parse(result.data.applyInviteStr);
                    } else {
                        this.tenantList = [];
                    }
                })
            }
        }).catch((error: any) => {
            console.log(error);
        });
    };


    @action
    cancleApply = (params: any) => {
        TenantInfoAPI.cancleApply(params).then((result: any) => {
            if (result?.data?.msg) {
                toast({
                    content: getLabel(result.data.i18nId, result.data.msg)
                });
            } else {
                runInAction(() => {
                    this.findApplyTenant();
                })
            }
        }).catch((error: any) => {
            console.log(error);
        });
    };

    // @action
    // acceptInvite = (obj: any) => {
    //     TenantInfoAPI.acceptInvite(obj).then((result: any) => {
    //         if (result.message) {
    //             message({
    //                 type: "error",
    //                 content: result.message,
    //             });
    //         } else {
    //             //TODO  接受邀请

    //         }
    //     }).catch((error: any) => {
    //         console.log(error);
    //     });
    // };


    // @action
    // rejectInvite = (obj: any) => {
    //     TenantInfoAPI.rejectInvite(obj).then((result: any) => {
    //         if (result.message) {
    //             message({
    //                 type: "error",
    //                 content: result.message,
    //             });
    //         } else {
    //             //TODO  拒绝邀请

    //         }
    //     }).catch((error: any) => {
    //         console.log(error);
    //     });
    // };
}

const instance = new mTeamsInfoStore();

export default instance;
